// extracted by mini-css-extract-plugin
export var label = "_ll-2";
export var slideContainer = "_ll-0";
export var slider = "_ll-1";